import { Component, input, OnDestroy, OnInit, output, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import { ReplaySubject, Subscription } from 'rxjs';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'eiq-select-group',
  templateUrl: 'select-group.component.html',
  styleUrls: ['select-group.component.scss']
})
export class SelectGroupComponent implements OnInit, OnDestroy, ControlValueAccessor {
  defaultOption = input<string>();
  hint = input<string>();
  label = input<string>();
  multiple = input<boolean>();
  optionGroups = input<Option<Option<unknown>[]>[]>();
  otherOption = input<Option<unknown>>();
  placeholder = input<string>();
  showDefaultOption = input<boolean>(false);
  tooltip = input<string>(null);

  selectionChange = output<MatSelectChange>();

  onChange: (value: string) => void;
  onTouched: () => void;

  control: FormControl;
  currentValue: unknown | unknown[];
  faInfoCircle = faInfoCircle;

  private input$ = new ReplaySubject(1);
  private subscriptions: Subscription[] = [];

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.control = this.ngControl.control as FormControl;
    this.subscriptions.push(
      this.input$.subscribe((inputValue: string) => {
        this.onTouched();
        this.onChange(inputValue);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: unknown | unknown[]): void {
    if (!value) {
      this.currentValue = null;
      return;
    }

    this.currentValue = value;
    this.input$.next(value);
  }

  setValue(change: MatSelectChange): void {
    this.currentValue = this.mapSetValue(change);
    this.input$.next(this.mapSetValue(change));
    this.selectionChange.emit(change);
  }

  clearValue(): void {
    this.currentValue = this.multiple ? [] : null;
    this.input$.next(this.multiple ? [] : null);
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }

  private mapSetValue(change: MatSelectChange): unknown | unknown[] {
    return change.value ? change.value : this.multiple ? [] : null;
  }
}
